import { render } from "./MPCClusterConfig.vue?vue&type=template&id=24a460d2&scoped=true&ts=true"
import script from "./MPCClusterConfig.vue?vue&type=script&lang=ts"
export * from "./MPCClusterConfig.vue?vue&type=script&lang=ts"

import "./MPCClusterConfig.vue?vue&type=style&index=0&id=24a460d2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a460d2"]])

export default __exports__